import _jsx from "@babel/runtime/helpers/jsx";
import clsx from 'clsx';
import React from 'react';
import PropTypes from 'prop-types';
import { bsClass, bsStyles, getClassSet, prefix, splitBsProps } from './utils/bootstrapUtils';
import { State } from './utils/StyleConfig';
import CloseButton from './CloseButton';
class Alert extends React.Component {
  render() {
    const {
      withIcon = true,
      onDismiss,
      closeLabel,
      className,
      children,
      ...props
    } = this.props;
    const [bsProps, elementProps] = splitBsProps(props);
    const dismissible = !!onDismiss;
    const classes = {
      ...getClassSet(bsProps),
      [prefix(bsProps, 'noicon')]: !withIcon,
      [prefix(bsProps, 'dismissible')]: dismissible
    };
    return /*#__PURE__*/React.createElement("div", Object.assign({}, elementProps, {
      role: "alert",
      className: clsx(className, classes)
    }), dismissible && /*#__PURE__*/_jsx(CloseButton, {
      onClick: onDismiss,
      label: closeLabel
    }), children);
  }
}
Alert.defaultProps = {
  withIcon: true,
  closeLabel: 'Close alert'
};
export default bsStyles(Object.values(State), State.INFO, bsClass('alert', Alert));